const homeCN = {
    HOME_01:'Home',
    HOME_02:'Email Registration',
    HOME_03:'Complete the login, you can enjoy the following features',
    HOME_04:'Cancel the company contact search results paging restrictions.',
    HOME_05:'More detailed and accurate company contact data.',
    HOME_06:'Open features of viewing contacts.',
    HOME_07:'Confirm logout?',
    HOME_08:'Logout',
    HOME_10:'Please select',
    HOME_11:'Failed to add collection, please use Ctrl + D to add, or manually set in the browser.',
    HOME_12:'Pricing and Plans',
    HOME_13:'Cancel',
    HOME_14:'Confirm',
    TITLE_FIND:'Let\'s find the plan that suits you best!',
    VISITOR:'Visitor',
    MON:'Mon',
    CPY_SEARCH:'Company search',
    CTT_SEARCH:'Contact search',
    CPY_DETAIL:'Company detail',
    CTT_DETAIL:'Contact email check',
    API_PARTNER:'API Partner',
    FREE_PLAN:'Free Plan',
    PRO_PLAN:'Pro Plan',
    ENTERPRISE_PLAN:'Enterprise Plan',
    PRICING:'Pricing',
    SEARCH_PER:'Search per day',
    PRICE_COMPARE:'Compare Plans',
    USED_NOW:'Used Now',
    CHECK_CONTACT:'Contacts per day',
    EXPORT_OPTION:'Export Option',
    MY_CONTACT:'My Contacts',
    MY_COMPANY:'My Companies',
    HIGH_CONTACT_SEARCH:'Advanced Contact search',
    HIGH_COMPANY_SEARCH:'Advanced Company search',
    PURCHASE:'Purchase',
    PER_SEARCH_COMPANY:'companies search per day',
    PER_SEARCH_CONTACT:'contacts search per day',
    PER_DETAIL_COMPANY:'companies detail per day',
    CONTACT_CHECK:'contacts check',
    EXPORT_TO_EMAIL:'Export data to email',
    EXPORT_TO_CSV:'Export data to csv',
    LOGIN_REG:'Login&Register',
    UPGRADE_SUCCESS:'Upgrade success',
    UPGRADE_WRONG:'Upgrade fail',
    SURE_PURCHASE:'Pay for the upgrade with account balance?',
    LOG_OUT:'Log out',
    UP_LEVEL_TIPS:'Pay for the upgrade plan with account amount.',
    PAY_MEAL_DEFICIENCY:'Out of account balance, Recharge to purchase the upgrade plan now.',
    CHARGE_FOR_BALANCE:'Don\'t upgrade now,Paid with account balance.',

    SEARCH_CMP:'Company Search',
    SEARCH_CCT:'Director Search',
    MY_COMPANY_AND_PERSON: 'My Favorites',
}
export default homeCN


// WEBPACK FOOTER //
// ./src/lan/en/en_home.js